/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
/**
 * globals.js MUST be imported before app_vue because some
 * Vue components make calls to API and globals.js methods must
 * be defined
 */
require('./components/globals');
window.moment = require('moment');

require('./app_vue');
require('./app_sentry');

const monizzeApi = require('./components/api-monizze');
for(let key in monizzeApi)
{
    window[key] = monizzeApi[key];
}

require('./bulma');
require('./bulma-extensions');
require('./components/error');
require('./extends/expired-storage.js');
require('./components/account.js');
